const raf = window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            function(callback) { window.setTimeout(callback, 1000 / 60); }

export default function(cb) {
    return raf.call(window, cb)
}



// WEBPACK FOOTER //
// ./web/js/util/raf.js